import { LitElement, css, html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import styles from "./export-pdf-modal.css?inline";
import { template } from "./template";

@customElement("export-pdf-modal")
export class ExportPdfModal extends LitElement {
  render() {
    return html`
        ${template(this)} 
    `;
  }

  static get styles() {
    return css`
      ${unsafeCSS(styles)}
    `;
  }

  @property()
  selectedRadioOption: string;

  @property()
  text: string;

  @property()
  selectedVisibilityLevelElement;

  @property()
  selectedPeriodDate;

  @property({ type: Array })
  arrayElements = [
    { label: "Element 1", value: "1" },
    { label: "Element 2", value: "2" },
    { label: "Element 3", value: "3" },
    { label: "Element 4", value: "4" },
  ];

  handleTest() {
    console.log(
      // this.selectedVisibilityLevelElement,
      this.selectedPeriodDate,
    );
  }
}
